import { Injectable } from '@angular/core';
import {
  AnimationController
} from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root'
})
export class SlideFromRight{

    constructor(
        private animationCtrl: AnimationController
    ) { }
    
    enter = (baseEl: HTMLElement) => {
        const root = baseEl.shadowRoot;
        const backdropAnimation = this.animationCtrl
            .create()
            .addElement(root!.querySelector('ion-backdrop')!)
            .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

        const wrapperAnimation = this.animationCtrl
            .create()
            .addElement(root!.querySelector('.modal-wrapper')!)
            .beforeStyles({opacity: 1})
            .fromTo('transform', 'translateX(100%)', 'translateX(0)');

        return this.animationCtrl
            .create()
            .addElement(baseEl)
            .easing('ease-out')
            .duration(400)
            .addAnimation([backdropAnimation, wrapperAnimation]);

    };
    
    leave = (baseEl: HTMLElement) => {
        return this.enter(baseEl).direction('reverse');
    };
}